import { Seo } from "@/components/Seo";
import { PortfolioGrid } from "@/components/PortfolioGrid";

export default function Realisations() {
  return (
    <div data-testid="realisations-page">
      <Seo
        title="Réalisations et maquettes — Koranex"
        description="Sites web, boutiques e-commerce, applications mobiles et refontes : explorez la galerie de concepts et réalisations de Koranex."
      />
      <header className="py-16 md:py-20 px-6 max-w-6xl mx-auto">
        <span className="text-xs font-mono-x uppercase text-[#38bdf8] tracking-widest kx-up inline-block">
          Galerie
        </span>
        <h1 className="font-display text-4xl sm:text-6xl md:text-7xl text-white leading-none mt-3 mb-6 kx-up delay-100">
          Nos réalisations
        </h1>
        <p className="text-base sm:text-lg text-slate-300 max-w-3xl leading-relaxed kx-up delay-200">
          Explorez nos concepts de sites web et d'applications mobiles. Chaque projet est pensé pour un secteur et un
          objectif précis — imaginez ce que Koranex peut créer pour vous.
        </p>
        <p className="text-[11px] font-mono-x text-slate-500 mt-6 kx-up delay-300">
          Les projets marqués « Concept de démonstration » sont des maquettes illustratives, pas des projets clients.
        </p>
      </header>

      <section className="pb-16 md:pb-24 px-6 max-w-6xl mx-auto">
        <PortfolioGrid showFilters />
      </section>
    </div>
  );
}
